module.exports = "/_next/static/images/offers3-74d78bc64691e7c13d9759efd53d0134.jpg.webp";